import { getAttrValue, getJoinedLocalizedAttrValues } from "@grandvisionhq/utils";
const createAltTag = (options) => {
  const variant = options.variant;
  const locale = options.locale;
  const labels = options.labels;
  const brand = getAttrValue(variant, "brand") || "";
  const accessoireType = getJoinedLocalizedAttrValues(variant, "accessoryType", locale);
  const accessoireColor = getJoinedLocalizedAttrValues(variant, "accessoryColor", locale);
  const frameColor = getJoinedLocalizedAttrValues(variant, "frameColor", locale);
  const lensColor = getJoinedLocalizedAttrValues(variant, "lensColor", locale);
  const replacementFrequency = getJoinedLocalizedAttrValues(variant, "replacementFrequency", locale);
  const solutionType = getAttrValue(variant, "solutionType")?.toString()?.replace("Eye drops", "");
  const packageOption = getAttrValue(variant, "packageOption");
  const colorsLabel = [lensColor, frameColor].filter((s) => s.trim() !== "").join(" / ");
  const packageQuantity = getAttrValue(variant, "packageQuantity");
  const packageQuantityLabel = packageQuantity && labels ? `${packageQuantity} ${packageQuantity === 1 ? labels.lens : labels.lenses} ${labels.perBox}` : "";
  return [
    options.prefix,
    brand,
    variant.name,
    solutionType,
    packageOption,
    replacementFrequency,
    packageQuantityLabel,
    colorsLabel,
    accessoireType,
    accessoireColor
  ].filter(Boolean).filter((entry) => entry != "").join(" ");
};
export {
  createAltTag
};
//# sourceMappingURL=create-alt-tag.js.map
